import React, { useEffect, useState } from 'react';
import { post, excelFileDownload, FMPexcelFileDownload } from '../../api';
import FileExportIcon from './FileExportIcon';
import { isSpinnerShowing, spinnerOff, spinnerOn } from '../Spinner';

export default (function FMPFileExport({tabView,fmpstatus}) {
 

  
  async function excelDownload() {
    //We are using project status for when excel download to provide name and active status we're sending in backend to get proper project

    spinnerOn();
    
    let projectInfo = {
      projectStatus: tabView,
      fmpstatus:fmpstatus
      
    }
   
    await FMPexcelFileDownload(projectInfo);
    spinnerOff();
  }

  return <FileExportIcon  onClick={() => excelDownload()} />;
});
